// Empty State Component - Reusable empty state display
import { t } from '../../../i18n.js';

export class EmptyState {
  constructor(icon, title, message) {
    this.icon = icon;
    this.title = title;
    this.message = message;
  }
  
  render() {
    const emptyState = document.createElement('div');
    emptyState.className = 'empty-state';
    
    emptyState.innerHTML = `
      <span class="empty-icon">${this.icon}</span>
      <h4>${this.title}</h4>
      <p>${this.message}</p>
    `;
    
    return emptyState;
  }
  
  // Static factory methods for common empty states
  static noContacts(itemType = 'email') {
    const msgKey = itemType === 'email' ? 'no_contacts_msg_email' : 'no_contacts_msg_appointment';
    return new EmptyState(
      '🔍',
      t('no_contacts_title'),
      t(msgKey)
    );
  }
  
  static noLeads() {
    return new EmptyState(
      '🎯',
      t('no_leads_title'),
      t('no_leads_msg')
    );
  }
  
  static noCampaigns() {
    return new EmptyState(
      '📢',
      t('no_campaigns_title'),
      t('no_campaigns_msg')
    );
  }
  
  static noAttachments() {
    return new EmptyState(
      '📎',
      t('no_attachments_title'),
      t('no_attachments_msg')
    );
  }
  
  static error(message) {
    return new EmptyState(
      '⚠️',
      t('error'),
      message
    );
  }
}
